import { render, staticRenderFns } from "./GongGdp.vue?vue&type=template&id=edae1db4&scoped=true&"
import script from "./GongGdp.vue?vue&type=script&lang=js&"
export * from "./GongGdp.vue?vue&type=script&lang=js&"
import style0 from "./GongGdp.vue?vue&type=style&index=0&id=edae1db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edae1db4",
  null
  
)

export default component.exports